import { useEffect, useState } from "react";

const FormatRelativeTime = (createdOn) => {
  if (!createdOn) return "";

  // API date is UTC without Z
  const createdDate = new Date(`${createdOn}Z`);
  const now = new Date();

  const diffInSeconds = Math.floor(
    (now.getTime() - createdDate.getTime()) / 1000
  );

  if (diffInSeconds < 0) {
    return "just now";
  }

  // Seconds
  if (diffInSeconds < 60) {
    return `${diffInSeconds} sec${diffInSeconds !== 1 ? "s" : ""} ago`;
  }

  // Minutes
  const diffInMinutes = Math.floor(diffInSeconds / 60);

  if (diffInMinutes < 60) {
    return `${diffInMinutes} min${diffInMinutes !== 1 ? "s" : ""} ago`;
  }

  // Hours
  const diffInHours = Math.floor(diffInMinutes / 60);

  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
  }

  // Calendar difference
  const createdLocal = new Date(createdDate);
  const nowLocal = new Date();

  // Years
  let years = nowLocal.getFullYear() - createdLocal.getFullYear();

  if (
    nowLocal.getMonth() < createdLocal.getMonth() ||
    (
      nowLocal.getMonth() === createdLocal.getMonth() &&
      nowLocal.getDate() < createdLocal.getDate()
    )
  ) {
    years--;
  }

  if (years >= 1) {
    return `${years} year${years !== 1 ? "s" : ""} ago`;
  }

  // Months
  let months =
    (nowLocal.getFullYear() - createdLocal.getFullYear()) * 12 +
    (nowLocal.getMonth() - createdLocal.getMonth());

  if (nowLocal.getDate() < createdLocal.getDate()) {
    months--;
  }

  if (months >= 1) {
    return `${months} month${months !== 1 ? "s" : ""} ago`;
  }

  // Days
  const diffInDays = Math.floor(diffInSeconds / (24 * 60 * 60));

  if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
  }

  // Weeks
  const diffInWeeks = Math.floor(diffInDays / 7);

  return `${diffInWeeks} week${diffInWeeks !== 1 ? "s" : ""} ago`;
};


function RelativeTime({ createdOn }) {
  const [time, setTime] = useState(() =>
    FormatRelativeTime(createdOn)
  );

  useEffect(() => {
    const updateTime = () => {
      setTime(FormatRelativeTime(createdOn));
    };

    updateTime();

    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, [createdOn]);

  return time;
}

export default RelativeTime;